
import request from "../utils/request"


import {
    miniId
} from '@/utils/apiUrl.js'

//获取分类和分类下的商品、sku
export function getCategoryAndProductAndSkuByMiniId(data = {}) {
    return request({
        url: "/statistics/bigScreen/getCategoryAndProductAndSkuByMiniId",
        data,
        method: 'GET',
    })
}


//交易快报
export function getNews(data = {}) {
    return request({
        url: "/order/orderinfo/list",
        data,
        method: 'GET',
    })
}



//获取首页菜单
export function getMenuList(data = {}) {
    return request({
        url: "/platform/menuposition/tree/" + miniId,
        data,
        method: "GET"
    })
}





//资讯列表 publishStatus: 1,type: "12"品牌政策，13品牌风采
export function getNewsList(data = {}) {
    return request({
        url: "/platform/news/pageForApp/",
        data,
        method: "GET"
    })
}

//资讯详情 
export function getNewsDetail(data={}) {
    return request({
        url: "/platform/news/getDetailForApp/" ,
        data,
        method: "GET"
    })
}


//获取协议内容type 2服务协议；3隐私政策；4关于我们
export function protocolContent(data={}) {
    return request({
        url: "/platform/miniappversion/getOneForApp/" ,
        data,
        method: "GET"
    })
}


//获取字典
export function getDict(name) {
    return request({
        url: "/platform/dict/list/"+name ,
        method: "GET"
    })
}


//首页品牌各种数量的统计
export function brandStat(name) {
    return request({
        url: "/user/commonbrand/brandStat/" ,
        method: "GET"
    })
}

//获取联系电话
export function getByMiniId(name) {
    return request({
        url: "/platform/busafterservice/getByMiniId/" ,
        method: "GET"
    })
}

/* 获取品牌风采 */
export function getBrandStyle(data={}) {
    return request({
        url: "/platform/contents/pageForApp",
        data,
        method: "GET"
    })
}
/* 获取品牌风采详情 */
export function getBrandStyleDetail(data={}) {
    return request({
        url: "/platform/contents/infoForApp/"+data.id,
        data,
        method: "GET"
    })
}





// WEBPACK FOOTER //
// ./src/api/api.js